import React from "react";
import { GameSettings } from "../types";
import QuickStartList from "../components/common/quick-start-list/quick-start-list";

export const textNumber = new Map<number, string>([
  [1, "ONE"],
  [2, "TWO"],
  [3, "THREE"],
  [4, "FOUR"],
  [5, "FIVE"],
  [6, "SIX"],
  [7, "SEVEN"],
  [8, "EIGHT"],
  [9, "NINE"],
  [10, "TEN"],
]);

export function numSwitches(numSwitches?: number) {
  // if (numSwitches !== undefined && numSwitches > 3) {
  //     guys.push(<li>*AND ANOTHER FANFIC SWAP* continue yet another fanfic!</li>)
  // }
  // if (numSwitches !== undefined && numSwitches > 4) {
  //     guys.push(<li>*YET ANOTHER FANFIC SWAP*  YOU PICKED ALL THE SWAPS, HUH?!</li>)
  // }

  return (
    <>
      <li>*THE FANFICS ARE SHUFFLED*</li>
      <li>
        Continue the story that was given to you. Stories will continue swapping
        until...
      </li>
    </>
  );
}

export const quickStartList = function (
  settings?: GameSettings,
  noTitle?: boolean
) {
  return (
    <>
      {!noTitle && (
        <u>
          <b>QUICK START GUIDE</b>
        </u>
      )}

      <ol>
        <li>
          {" "}
          Write{" "}
          {settings ? (
            <b>{textNumber.get(settings.num_characters_submit)}</b>
          ) : (
            "some"
          )}{" "}
          characters.
        </li>
        <li>*CHARACTERS ARE SHUFFLED*</li>
        <li>
          {" "}
          Pick{" "}
          {settings ? (
            <b>{textNumber.get(settings.num_characters_select)}</b>
          ) : (
            "some"
          )}{" "}
          characters.
        </li>

        <li> Write the beginning of the story.</li>
        {numSwitches(settings?.num_switches)}

        <li>Title your work from the beginning.</li>
        <li>Take turns reading!</li>
        <li>React! more reacts = more points.</li>
        <li>Award your favourites with bonus points!</li>
      </ol>
      <p>
        The stories and writers that get the most reacts and bonus votes are the
        winners!
      </p>
    </>
  );
};

export const body = {
  // QUICK START GUIDE. INSIDE GAME. AFTER LOBBY. NOT MENU. NOT HOW TO PLAY.
  contentGOTIT: function (settings: GameSettings) {
    return (
      <>
        <QuickStartList>
          {/*<b><u>WELCOME TO FRANTIC FANFIC</u></b>*/}
          {/*<p>Here's an overview on how this game mode works.</p>*/}

          {quickStartList(settings)}

          <p>yes! You can save your stories after the game.</p>
          <p>
            Do not share any personal identifiable information, illegal
            activities, or otherwise harmful material within these stories. By
            clicking "GOT IT" you agree to our full{" "}
            <a
              href="https://franticfanfic.com/terms"
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>
            .
          </p>
        </QuickStartList>
      </>
    );
  },
};

const footers = {
  submit: "OK, GOT IT!",
  loading: "loading...",
};
